export function getZIndexProperty(parentElement){
    return getComputedStyle(parentElement).getPropertyValue("z-index");
}


// WEBPACK FOOTER //
// ./src/lib/ClassPropertiesUtilities.js